import 'antd/dist/antd.min.css';
import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from '../../theme';
import { GlobalStyle } from './GlobalStyle';
export const ACThemeProvider = ({ children }) => (React.createElement(ThemeProvider, { theme: theme },
    children,
    React.createElement(GlobalStyle, null)));
